export const getBillingCartUrl = ({
  isAdmin,
  groupId,
  entityId,
}: {
  isAdmin: boolean;
  groupId: string;
  entityId: string;
}) =>
  isAdmin
    ? `/admin/crm/${groupId}/billing/cart?entity=${entityId}`
    : `/settings/billing/cart?entity=${entityId}`;
